import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const IssueTranslationKeys = {
  issue: translationKey('Issue'),
  issues: translationKey('Issues'),
  noIssuesCreateFirst: translationKey('dashboard_no_issues_create_first'),
  noIssuesFiltersView: translationKey('dashboard_no_issues_filters_view'),
  noIssuesSearchPhraseView: translationKey('dashboard_no_issues_search_phrase_view'),
  noIssuesTitle: translationKey('dashboard_no_issues_title'),
  searchPlaceholder: translationKey('dashboard_search_placeholder'),
  editLocationCompletedAreaLabel: translationKey('edit_location_completed_area_label'),
  editLocationDeleteAreaLabel: translationKey('edit_location_delete_area_label'),
  editLocationPlannedAreaLabel: translationKey('edit_location_planned_area_label'),
  editLocationTypeAreaLabel: translationKey('edit_location_type_area_label'),
  editLocationTypePinLabel: translationKey('edit_location_type_pin_label'),
  goToIssue: translationKey('go_to_issue'),
  amountPercentageLabel: translationKey('issue_amount_percentage_label'),
  cardDelay: translationKey('issue_card_delay'),
  cardFinalCompletionDate: translationKey('issue_card_final_completion_date'),
  cardFinalExecutionTime: translationKey('issue_card_final_execution_time'),
  cardNoData: translationKey('issue_card_no_data'),
  cardPlannedCompletionDate: translationKey('issue_card_planned_completion_date'),
  cardPlannedExecutionTime: translationKey('issue_card_planned_execution_time'),
  changelogDocumentDescriptionModify: translationKey('issue_changelog_document_description_modify'),
  changelogDocumentExportedToDocumentation: translationKey('issue_changelog_document_exported_to_documentation'),
  changelogDocumentUploadFailure: translationKey('issue_changelog_document_upload_failure'),
  changelogDocumentUploadPending: translationKey('issue_changelog_document_upload_pending'),
  changelogDocumentUploadSuccess: translationKey('issue_changelog_document_upload_success'),
  changelogDocumentationImported: translationKey('issue_changelog_documentation_imported'),
  changelogDrawingClear: translationKey('issue_changelog_drawing_clear'),
  changelogDrawingMergeFailure: translationKey('issue_changelog_drawing_merge_failure'),
  changelogDrawingMergeUploadedUnavailable: translationKey('issue_changelog_drawing_merge_uploaded_unavailable'),
  changelogDrawingSuccess: translationKey('issue_changelog_drawing_success'),
  changelogDrawingUploadFailure: translationKey('issue_changelog_drawing_upload_failure'),
  changelogDrawingUploadPending: translationKey('issue_changelog_drawing_upload_pending'),
  changelogEventCreate: translationKey('issue_changelog_event_create'),
  changelogIssueLocalized: translationKey('issue_changelog_issue_localized'),
  changelogIssueLocationConfirmed: translationKey('issue_changelog_issue_location_confirmed'),
  changelogLinkedDocumentationRemoved: translationKey('issue_changelog_linked_documentation_removed'),
  changelogMapUnavailable: translationKey('issue_changelog_map_unavailable'),
  changelogStageChange: translationKey('issue_changelog_stage_change'),
  changelogStageChangeAuto: translationKey('issue_changelog_stage_change_auto'),
  changelogSystemAuthor: translationKey('issue_changelog_system_author'),
  changelogUserAccessCreate: translationKey('issue_changelog_user_access_create'),
  changelogUserAccessDelete: translationKey('issue_changelog_user_access_delete'),
  changelogUserAccessModify: translationKey('issue_changelog_user_access_modify'),
  changelogWorkflowDecisionApproved: translationKey('issue_changelog_workflow_decision_approved'),
  changelogWorkflowDecisionRejected: translationKey('issue_changelog_workflow_decision_rejected'),
  columnHeaderLastDecision: translationKey('issue_column_header_last_decision'),
  columnLabelState: translationKey('issue_column_label_state'),
  countPlural: translationKey('issue_count_plural'),
  createDataSavedInfo: translationKey('issue_create_data_saved_info'),
  createNew: translationKey('issue_create_new'),
  createNewHeader: translationKey('issue_create_new_header'),
  delayBeforeTime: translationKey('issue_delay_before_time'),
  delayLabel: translationKey('issue_delay_label'),
  delayOnTime: translationKey('issue_delay_on_time'),
  delayValue: translationKey('issue_delay_value'),
  dropFilesToUpload: translationKey('issue_drop_files_to_upload'),
  eventsAddLabel: translationKey('issue_events_add_label'),
  eventsDialogAddTitle: translationKey('issue_events_dialog_add_title'),
  eventsDialogSaveTitle: translationKey('issue_events_dialog_save_title'),
  eventsDialogTitleEdit: translationKey('issue_events_dialog_title_edit'),
  eventsEmptyListHint: translationKey('issue_events_empty_list_hint'),
  eventsFilterDecisions: translationKey('issue_events_filter_decisions'),
  eventsFilterEmails: translationKey('issue_events_filter_emails'),
  eventsFilterMessages: translationKey('issue_events_filter_messages'),
  eventsNotificationAddSuccess: translationKey('issue_events_notification_add_success'),
  eventsNotificationDeleteSuccess: translationKey('issue_events_notification_delete_success'),
  eventsNotificationEditSuccess: translationKey('issue_events_notification_edit_success'),
  eventsReply: translationKey('issue_events_reply'),
  eventsReplyAll: translationKey('issue_events_reply_all'),
  eventsReplyAllTooltip: translationKey('issue_events_reply_all_tooltip'),
  eventsReplyTooltip: translationKey('issue_events_reply_tooltip'),
  eventsTableHeaderCreatedAt: translationKey('issue_events_table_header_created_at'),
  eventsTableHeaderCreatedBy: translationKey('issue_events_table_header_created_by'),
  eventsTableHeaderName: translationKey('issue_events_table_header_name'),
  fieldPlaceholderEmpty: translationKey('issue_field_placeholder_empty'),
  fieldUserUnassigned: translationKey('issue_field_user_unassigned'),
  formInspectionSiteEditWarning: translationKey('issue_form_inspection_site_edit_warning'),
  headerGoToInspection: translationKey('issue_header_go_to_inspection'),
  headerInspectionPreviewError: translationKey('issue_header_inspection_preview_error'),
  inspectionNumberColumnHeader: translationKey('issue_inspection_number_column_header'),
  lastDecisionApproved: translationKey('issue_last_decision_approved'),
  lastDecisionNone: translationKey('issue_last_decision_none'),
  lastDecisionRejected: translationKey('issue_last_decision_rejected'),
  linkedDocumentationCaptionCurrentVersion: translationKey('issue_linked_documentation_caption_current_version'),
  linkedDocumentationCaptionNoCurrentVersion: translationKey('issue_linked_documentation_caption_no_current_version'),
  linkedDocumentationCaptionVersion: translationKey('issue_linked_documentation_caption_version'),
  linkedDocumentationEmpty: translationKey('issue_linked_documentation_empty'),
  linkedDocumentationLinkToDocumentation: translationKey('issue_linked_documentation_link_to_documentation'),
  linkedDocumentationLinkToVersion: translationKey('issue_linked_documentation_link_to_version'),
  linkedDocumentationLinkWith: translationKey('issue_linked_documentation_link_with'),
  linkedDocumentationOutdatedVersionNotice: translationKey('issue_linked_documentation_outdated_version_notice'),
  linkedDocumentationOutdatedVersionNoticeWithoutCurrent: translationKey('issue_linked_documentation_outdated_version_notice_without_current'),
  listSendReportAction: translationKey('issue_list_send_report_action'),
  mapConfirmLocationOnCurrentVersion: translationKey('issue_map_confirm_location_on_current_version'),
  mapCurrentVersionNotSuitable: translationKey('issue_map_current_version_not_suitable'),
  mapGoToDocumentation: translationKey('issue_map_go_to_documentation'),
  mapLocatedOnCurrentVersion: translationKey('issue_map_located_on_current_version'),
  mapLocatedOnOtherVersion: translationKey('issue_map_located_on_other_version'),
  mapLocatedOnPreviousMap: translationKey('issue_map_located_on_previous_map'),
  mapLocatedOnWithdrawnVersion: translationKey('issue_map_located_on_withdrawn_version'),
  mapLocatedVersionOverlay: translationKey('issue_map_located_version_overlay'),
  mapLocationConfirmed: translationKey('issue_map_location_confirmed'),
  mapNotLocated: translationKey('issue_map_not_located'),
  mapPositionHint: translationKey('issue_map_position_hint'),
  mapUnavailableFor: translationKey('issue_map_unavailable_for'),
  mapVersionPreviewMeta: translationKey('issue_map_version_preview_meta'),
  mapWithdrawnWarning: translationKey('issue_map_withdrawn_warning'),
  navigationBackToGallery: translationKey('issue_navigation_back_to_gallery'),
  navigationBackToIssuePreview: translationKey('issue_navigation_back_to_issue_preview'),
  navigationBackToList: translationKey('issue_navigation_back_to_list'),
  notificationDeleteSuccess: translationKey('issue_notification_delete_success'),
  notificationFilesAdded: translationKey('issue_notification_files_added'),
  notificationRestoreSuccess: translationKey('issue_notification_restore_success'),
  numberColumnHeader: translationKey('issue_number_column_header'),
  previewDescriptionEditDialogTitle: translationKey('issue_preview_description_edit_dialog_title'),
  previewDropZoneDialogTitle: translationKey('issue_preview_drop_zone_dialog_title'),
  previewDropZoneTittle: translationKey('issue_preview_drop_zone_tittle'),
  previewDropZoneTittleDragged: translationKey('issue_preview_drop_zone_tittle_dragged'),
  previewDropZoneTooMuchFiles: translationKey('issue_preview_drop_zone_too_much_files'),
  previewDropZoneTooMuchFilesMaxCountInfo: translationKey('issue_preview_drop_zone_too_much_files_max_count_info'),
  previewDropZoneTooMuchFilesTitle: translationKey('issue_preview_drop_zone_too_much_files_title'),
  previewExtendedFieldsHeader: translationKey('issue_preview_extended_fields_header'),
  previewGalleryCantPreviewMessage: translationKey('issue_preview_gallery_cant_preview_message'),
  previewGalleryDescriptionEditLabel: translationKey('issue_preview_gallery_description_edit_label'),
  previewGalleryDrawingLabel: translationKey('issue_preview_gallery_drawing_label'),
  previewGalleryFileDownloadLabel: translationKey('issue_preview_gallery_file_download_label'),
  previewGalleryFileRemoveLabel: translationKey('issue_preview_gallery_file_remove_label'),
  previewGalleryLinkedDocUnlinkLabel: translationKey('issue_preview_gallery_linked_doc_unlink_label'),
  previewHistoryAccessChangeLabel: translationKey('issue_preview_history_access_change_label'),
  previewHistoryAddedLabel: translationKey('issue_preview_history_added_label'),
  previewHistoryAttachmentLabel: translationKey('issue_preview_history_attachment_label'),
  previewHistoryChangeMessage: translationKey('issue_preview_history_changeMessage'),
  previewHistoryChangedLabel: translationKey('issue_preview_history_changed_label'),
  previewHistoryCleanedLabel: translationKey('issue_preview_history_cleaned_label'),
  previewHistoryCollapseAll: translationKey('issue_preview_history_collapse_all'),
  previewHistoryCreatedLabel: translationKey('issue_preview_history_created_label'),
  previewHistoryDeletedLabel: translationKey('issue_preview_history_deleted_label'),
  previewHistoryDiffNone: translationKey('issue_preview_history_diff_none'),
  previewHistoryDrawingLabel: translationKey('issue_preview_history_drawing_label'),
  previewHistoryEntityDocumentRemoved: translationKey('issue_preview_history_entity_document_removed'),
  previewHistoryEntityEvent: translationKey('issue_preview_history_entity_event'),
  previewHistoryEntityEventRemoved: translationKey('issue_preview_history_entity_event_removed'),
  previewHistoryEntityIssue: translationKey('issue_preview_history_entity_issue'),
  previewHistoryFile: translationKey('issue_preview_history_file'),
  previewHistoryLinkedDocumentationLabel: translationKey('issue_preview_history_linked_documentation_label'),
  previewHistoryLocationLabel: translationKey('issue_preview_history_location_label'),
  previewHistoryRemovedLabel: translationKey('issue_preview_history_removed_label'),
  previewHistoryRestoredLabel: translationKey('issue_preview_history_restored_label'),
  previewHistoryStageChangeLabel: translationKey('issue_preview_history_stage_change_label'),
  previewHistoryTitle: translationKey('issue_preview_history_title'),
  previewHistoryTitleRemoved: translationKey('issue_preview_history_title_removed'),
  previewHistoryTitleRestored: translationKey('issue_preview_history_title_restored'),
  previewHistoryUncollapseAll: translationKey('issue_preview_history_uncollapse_all'),
  previewHistoryViewDownloadFileLabel: translationKey('issue_preview_history_view_downloadFile_label'),
  previewHistoryViewEventLabel: translationKey('issue_preview_history_view_event_label'),
  previewHistoryWorkflowDecisionLabel: translationKey('issue_preview_history_workflow_decision_label'),
  previewIssueRemoved: translationKey('issue_preview_issue_removed'),
  previewLabelCreatedBy: translationKey('issue_preview_label_created_by'),
  previewLabelCreationDate: translationKey('issue_preview_label_creation_date'),
  previewLabelEvents: translationKey('issue_preview_label_events'),
  previewLabelHashtag: translationKey('issue_preview_label_hashtag'),
  previewLocationHeader: translationKey('issue_preview_location_header'),
  previewNoEditPermissionInfo: translationKey('issue_preview_noEdit_permission_info'),
  previewShowLessButtonTitle: translationKey('issue_preview_showLess_button_title'),
  previewShowMoreButtonTitle: translationKey('issue_preview_showMore_button_title'),
  responseToAuthorDelayLabel: translationKey('issue_response_to_author_delay_label'),
  sectionLinkedDocumentation: translationKey('issue_section_linked_documentation'),
  startDateDelayLabel: translationKey('issue_start_date_delay_label'),
  tabCommunication: translationKey('issue_tab_communication'),
  tabHistory: translationKey('issue_tab_history'),
  tableViewHeaderCreationDate: translationKey('issue_tableView_header_creation_date'),
  tableViewHeaderModifiedAtDate: translationKey('issue_tableView_header_modifiedAt_date'),
  tableViewSettingsLabel: translationKey('issue_tableView_settings_label'),
  tableActionGenerateWorkbook: translationKey('issue_table_action_generate_workbook'),
  titleColumnHeader: translationKey('issue_title_column_header'),
  typeDetected: translationKey('issue_type_detected'),
  typeResolved: translationKey('issue_type_resolved'),
  uploadFromDevice: translationKey('issue_upload_from_device'),
  withinInspection: translationKey('issue_within_inspection'),
  workflowPanelClose: translationKey('issue_workflow_panel_close'),
  workflowPanelCollapse: translationKey('issue_workflow_panel_collapse'),
  workflowPanelExpand: translationKey('issue_workflow_panel_expand'),
  writeToIssueEmailAddress: translationKey('write_to_issue_email_address'),
} as const satisfies Record<string, TranslationKey>;
